export default __webpack_public_path__ + "assets/images/32e51d28bf1e8f0af9453e0493857813.png";